import { Component, OnDestroy, OnInit } from '@angular/core';
import { User } from '@models/Core/User';
import { AuthenticationRequestService } from '@services/auth/authentication.request.service';
import { AuthenticationService } from '@services/auth/authentication.service';
import { BusService } from '@services/bus.service';
import { ConfigService } from '@services/config.service';
import { EventsService } from '@services/events.service';

import { Idea } from '../../models/Sessions/Idea/Idea';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  ideas: Idea[] = [];
  // allIdeas: Idea[] = [];
  // recommendedIdeas: Idea[] = [];
  recentIdeas: Idea[] = [];
  topRatedIdeas: Idea[] = [];
  me: any;

  // $ideas = new Subject<Idea[]>();

  recomTargetUser: User = undefined;

  constructor(
    private bus: BusService,
    private events: EventsService,
    private authRequest: AuthenticationRequestService,
    private auth: AuthenticationService,
    private config: ConfigService,
  ) {}

  ngOnInit() {
    this.bus.publish(this.events.requested.data.user.me);

    this.bus.subscribe(
      this.events.received.data.session.all.success,
      this.updateSessions,
      this,
    );
    this.bus.subscribe(
      this.events.received.data.user.me.success,
      this.updateMe,
      this,
    );

    // zip(this.$ideas, this.recom.recommendations).subscribe(
    //   ([ideas, recoms]) => {
    //     this.allIdeas = ideas;
    //     this.recommendedIdeas = recoms
    //       .map(recom => ideas.find(idea => idea._id === recom.idea_id))
    //       .filter(idea => {
    //         if (!idea) {
    //           return false;
    //         }
    //         //
    //         // so the idea is not published and so its not going to be recommended.
    //         // most people do not have permission to see this to begin with,
    //         // moderators and admins also do not need to get recommendations of working
    //         // drafts.
    //         //
    //         if (!idea.published) {
    //           return false;
    //         }

    //         const participant = idea.session.config.participants.find(
    //           p => p.user_id === this.me._id,
    //         );
    //         if (!participant) {
    //           return false;
    //         }
    //         if (participant._id === idea.created_by) {
    //           return false;
    //         }
    //         if (
    //           idea.collaborators.find(c => c.participant_id === participant._id)
    //         ) {
    //           return false;
    //         }
    //         return true;
    //       });
    //   },
    // );
  }

  updateMe(user) {
    if (!this.me) {
      this.me = user;
      this.bus.publish(this.events.requested.data.session.all);
    }
  }

  updateSessions(sessions) {
    this.ideas = [];
    sessions.forEach(session => {
      session.me = session.config.participants.find(
        participant => participant.user_id === this.me._id,
      );
      if (
        !session.config.restricted ||
        session.me.role <= this.config.roles.SESSION_MODERATOR
      ) {
        session.data.ideas
          .filter(idea => !idea.deleted_at)
          .forEach(idea => {
            idea.session = session;
            this.ideas.push(idea);
          });
      }
    });

    // this.$ideas.next(this.ideas);

    this.updateRecentIdeas();
    this.updateTopRatedIdeas();
  }

  updateRecentIdeas() {
    this.recentIdeas = [...this.ideas]
      .filter(
        idea =>
          idea.published ||
          idea.created_by === idea.session.me._id ||
          idea.collaborators.find(
            collaborator => collaborator.participant_id === idea.session.me._id,
          ),
      )
      .sort((a, b) => (this.ideaLID(b) as any) - (this.ideaLID(a) as any));
  }

  updateTopRatedIdeas() {
    this.topRatedIdeas = [...this.ideas]
      .filter(idea => idea.votes.length > 0 && idea.published)
      .sort((a, b) => this.ideaRatingScore(b) - this.ideaRatingScore(a));
  }

  //
  // this function will calculate the last interaction date (by anyone)
  // with an idea.
  //
  ideaLID(idea: Idea): Date {
    let lid = new Date(idea.last_changed);
    idea.comments.forEach(comment => {
      const date = new Date(comment.created_at);
      if (date > lid) {
        lid = date;
      }
    });

    return lid;
  }

  ideaRatingScore(idea: Idea): number {
    if (idea.votes.length === 0) {
      return -1;
    }

    const xsum = idea.votes.reduce((sum, vote) => sum + vote.x, 0);
    const ysum = idea.votes.reduce((sum, vote) => sum + vote.y, 0);
    return (xsum + ysum) / idea.votes.length;
  }

  get followedIdeas() {
    return this.ideas
      .filter(
        idea =>
          idea.published ||
          idea.created_by === idea.session.me._id ||
          idea.collaborators.find(
            collaborator => collaborator.participant_id === idea.session.me._id,
          ),
      )
      .filter(
        idea =>
          idea.followers &&
          idea.followers.find(
            follower => follower.participant_id === idea.session.me._id,
          ),
      );
  }

  get isAdmin() {
    return this.auth.isAdmin;
  }

  // changeRecomTarget() {
  //   const ref = this.modal.open(AdminUserSelectComponent, {
  //     centered: true,
  //     size: 'lg',
  //   });

  //   this.auth.getCurrentUser.subscribe(current => {
  //     ref.componentInstance.current = this.recomTargetUser || current;
  //     ref.result.then(user => {
  //       if (user) {
  //         this.recomTargetUser = user;
  //         this.recom
  //           .recommendationsForUser(this.recomTargetUser)
  //           .subscribe(recoms => {
  //             this.recommendedIdeas = recoms
  //               .map(recom =>
  //                 this.allIdeas.find(idea => idea._id === recom.idea_id),
  //               )
  //               .filter(idea => !!idea && idea.published);
  //           });
  //       }
  //     });
  //   });
  // }

  ngOnDestroy() {
    this.bus.unsubscribe(
      this.events.received.data.session.all.success,
      this.updateSessions,
    );
    this.bus.unsubscribe(
      this.events.received.data.user.me.success,
      this.updateMe,
    );
  }
}
